import type { FC } from 'react'
import React from 'react'

import Pane from './pane'
import type { ModalPaneProps } from './types'
import { EMPTY_OBJECT } from '../../../utils/object'
import { getColor, omitColor } from '../../../utils/props-utils'
import Modal from '../../_utils/modal/modal'

const ModalPane: FC<ModalPaneProps> = props => {
  const {
    zIndex,
    open,
    onClose,
    BackdropProps,
    children,
    disablePortal,
    disableScrollLock,
    disableBackdropClick,
    useModalAsBackdrop,
    modalProps = EMPTY_OBJECT,
    sx = EMPTY_OBJECT,
    variant,
    ...rest
  } = props

  const combinedColors = {
    bg: 'white',
    ...getColor(rest),
    ...getColor(sx)
  }
  return (
    <Modal
      {...{
        open,
        onClose,
        BackdropProps,
        disableBackdropClick,
        zIndex,
        disablePortal,
        disableScrollLock,
        useModalAsBackdrop,
        ...modalProps
      }}
    >
      <Pane
        {...{ ...combinedColors, ...omitColor(rest), display: 'flex' }}
        sx={omitColor(sx)}
        variant={variant}
      >
        {children}
      </Pane>
    </Modal>
  )
}

export default ModalPane
